import React from 'react';
import { cn } from '@/lib/utils';

export interface MobileCardProps {
  title: string;
  subtitle?: string;
  meta?: React.ReactNode;
  badges?: React.ReactNode;
  accent?: string;        // CSS color string for left border, e.g. '#ef4444'
  onClick?: () => void;
}

export function MobileCard({ title, subtitle, meta, badges, accent, onClick }: MobileCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full text-left bg-white rounded-lg border border-slate-200 p-3',
        'transition-colors active:bg-slate-50',
        onClick ? 'cursor-pointer' : 'cursor-default',
      )}
      style={accent ? { borderLeftWidth: '3px', borderLeftColor: accent } : undefined}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="font-semibold text-slate-900 text-sm leading-snug">{title}</span>
        {badges && (
          <div className="flex gap-1 flex-shrink-0 flex-wrap justify-end">{badges}</div>
        )}
      </div>
      {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      {meta && <div className="text-xs text-slate-500 mt-1">{meta}</div>}
    </button>
  );
}

// Accent colour helpers (CSS colour strings, not Tailwind classes)
export function priorityAccent(priority: string): string {
  return ({ critical: '#dc2626', high: '#ef4444', medium: '#f97316', low: '#94a3b8' } as Record<string, string>)[priority] ?? '#94a3b8';
}

export function criticalityAccent(c: string): string {
  return ({ critical: '#dc2626', high: '#ef4444', medium: '#3b82f6', low: '#94a3b8' } as Record<string, string>)[c] ?? '#94a3b8';
}
